import { render, staticRenderFns } from "./WorkflowTestAuditTrail.vue?vue&type=template&id=46048b7c"
import script from "./WorkflowTestAuditTrail.vue?vue&type=script&lang=js"
export * from "./WorkflowTestAuditTrail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports